import { createAction, props } from '@ngrx/store';

export const updatePaymentRun = createAction(
  '[PaymentRun] Load UpdatePaymentRun',
  props<{ request: { businessId: string; businessPaymentRunId: string } }>()
);

export const updatePaymentRunSuccess = createAction('[PaymentRun] Load UpdatePaymentRun Success', props<{ response: string }>());

export const updatePaymentRunFailure = createAction('[PaymentRun] Load UpdatePaymentRun Failure', props<{ error: Error | any }>());
